import { route } from 'react-router-typesafe-routes/dom';

export const AnnouncementsRoutes = {
	ANNOUNCEMENTS: route('announcements', {}),
};
